module.exports = __webpack_public_path__ + "img/newspapers_button_right_down.e7a8cbe1.png";